var isContentfulAsset = function(url) {
    return url.includes("images.ctfassets.net");
};
export default isContentfulAsset;
